import { FormikProps } from "formik";
import { PersonDto } from "../../../../../../interfaces/schema";
import { extractCurrentPersonFirma } from "../../../../../../util/person";
import { TextInputFormik } from "../../../../../formcontrols/InputItem";
import { SelectFormik } from "../../../../../formcontrols/Select";
import { FormikTextArea } from "../../../../../formcontrols/TextArea";
import { DisplayItem } from "../../../../../formcontrols/DisplayItem";

const PersonStamoFieldset2 = ({
  editMode,
  formik,
  isLoading,
  person,
}: {
  formik: FormikProps<IUpdatePersonFormik>;
  isLoading: boolean;
  editMode: boolean;
  person: PersonDto;
}) => {
  const currentFirma = extractCurrentPersonFirma(person);
  const afsendStandardItems = [
    { label: "Prioriter E-mail, arbejde", value: "false" },
    { label: "Prioriter E-mail, privat", value: "true" },
  ];
  return (
    <fieldset
      className="col-12 col-xl-6 d-flex flex-column gap-4"
      disabled={isLoading}
    >
      <div className="c-card c-item-list">
        <h4 className="flex-100">Kontaktoplysninger</h4>
        <div>
          <h5 className="form-label">Telefon, arbejde</h5>
          <div className="form-control--value">
            {currentFirma && currentFirma.firma.tlf ? (
              currentFirma.firma.tlf
            ) : (
              <span className="text-muted">-</span>
            )}
          </div>
        </div>
        <div>
          <h5 className="form-label">E-mail, arbejde</h5>
          {!currentFirma && (
            <div className="form-control--value">
              <span className="text-muted">-</span>
            </div>
          )}
          {currentFirma && (
            <div className="form-control--value" key={currentFirma.firma.id}>
              {currentFirma.emailArbejde ? (
                currentFirma.emailArbejde
              ) : (
                <span className="text-muted">-</span>
              )}
            </div>
          )}
        </div>
        {editMode && (
          <div>
            <TextInputFormik
              config={{
                component: "textinput",
                id: "TlfMobilNr",
                initialValue: formik.initialValues.TlfMobilNr ?? "",
                label: "Mobiltelefon",
                placeholder: "Indtast mobil",
              }}
              formik={formik}
            />
          </div>
        )}
        {!editMode && (
          <div>
            <h5 className="form-label">Mobiltelefon</h5>
            <div className="form-control--value is-editable">
              {!person.tlfMobilNr && <span className="text-muted">-</span>}
              {person.tlfMobilNr && person.tlfMobilNr.length > 0 && (
                <>{person.tlfMobilNr}</>
              )}
            </div>
          </div>
        )}

        {editMode && (
          <div>
            <TextInputFormik
              config={{
                component: "textinput",
                id: "EmailPrivat",
                initialValue: formik.initialValues.EmailPrivat ?? "",
                label: "E-mail, privat",
                placeholder: "Indtast e-mail",
              }}
              formik={formik}
            />
          </div>
        )}
        {!editMode && (
          <div>
            <h5 className="form-label">E-mail, privat</h5>
            <div className="form-control--value is-editable">
              {!person.emailPrivat && <span className="text-muted">-</span>}
              {person.emailPrivat && person.emailPrivat.length > 0 && (
                <>{person.emailPrivat}</>
              )}
            </div>
          </div>
        )}
        {editMode && (
          <div>
            <SelectFormik
              data={afsendStandardItems}
              config={{
                component: "select",
                id: "prioriterEmailPrivat",
                label: "Afsend standard",
                placeholder: "Vælg...",
              }}
              formik={formik}
              triggerClassName="form-select--email"
            />
          </div>
        )}
        {!editMode && (
          <div className="flex">
            <DisplayItem
              label="Afsend standard"
              text={
                person.prioriterEmailPrivat
                  ? "Prioriter E-mail, privat"
                  : "Prioriter E-mail, arbejde"
              }
              isEditable
            />
          </div>
        )}
      </div>
      <div className="c-card">
        {editMode && (
          <div>
            <FormikTextArea
              config={{
                component: "textarea",
                id: "Bemaerkninger",
                label: "Bemærkninger",
                initialValue: formik.initialValues.Bemaerkninger ?? "",
              }}
              formik={formik}
            />
          </div>
        )}
        {!editMode && (
          <div>
            <h5 className="form-label">Bemærkninger</h5>
            <div
              className="form-control--value is-editable"
              style={{ whiteSpace: "pre-wrap", minHeight: "4.4rem" }}
            >
              {(!person.bemaerkninger || person.bemaerkninger.length === 0) && (
                <span className="text-muted">-</span>
              )}
              {person.bemaerkninger &&
                person.bemaerkninger.length > 0 &&
                person.bemaerkninger}
            </div>
          </div>
        )}
      </div>
    </fieldset>
  );
};

export default PersonStamoFieldset2;
